import React, { useEffect, useState, useRef, useMemo } from "react";
import { Tooltip, Modal } from "antd";
import {
  IconEdit,
  IconBlockSuccess,
  IconBlockDenied,
  IconExclamation,
  IconBlockApply,
  IconSandTimer,
} from "../Layout/Icons";
import { useDispatch } from "react-redux";
import { AiOutlineExclamation } from "react-icons/ai";
import {
  antdMessageError,
  numberRound,
  relDiff,
  returnEuroString,
} from "../../helpers/Utils";
import { putImums } from "../../redux/Actions/imum_action";
import { MdCheckCircleOutline, MdOutlinePriceCheck } from "react-icons/md";
const { confirm } = Modal;
import styled from "styled-components";
import { formatDateTime } from "../../utils/date";

const ImumNewPriceChange = ({
  country,
  value,
  id,
  parent_id,
  active: activeParent,
  setActive,
  countriesAreDisplayed,
  old_price,
  related_ids,
  variables,
}) => {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    if (!activeParent || !id) return;
    if (activeParent == id) {
      inputRef.current.focus();
    }
  }, [activeParent, id]);

  const handleActive = (val = false) => setActive(val);
  const handleSave = async (type = "regular") => {
    try {
      if (inputValue.trim() == "0") return antdMessageError("Can't be zero");
      if (inputValue.trim() == "") return antdMessageError("Can't be empty");
      const new_price = inputValue.replace(",", ".");
      let final_sum = relDiff(+inputValue, +value);
      if (inputValue < value) {
        final_sum = -relDiff(+value, +inputValue);
      }
      if (final_sum >= 30 || final_sum <= -30) {
        return confirm({
          title: "Are you sure?",
          icon: <IconExclamation className="text-primary" />,
          content: `Your amount is ${
            final_sum >= 30 ? "higher" : "lower"
          } than before ${
            final_sum == "Infinity" ? "" : `${numberRound(final_sum)}%`
          }. Was: ${value} now: ${new_price} `,
          onOk() {
            request(new_price, type);
            console.log("OK");
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      }
      return request(new_price, type);
    } catch (err) {
      console.log("ERROR: ", err);
    }
  };

  const request = async (price, type) => {
    try {
      const { success } = await dispatch(
        putImums(
          id,
          {
            price,
          },
          parent_id,
          type == "related_ids" ? related_ids : []
        )
      );
      if (success) return setActive(false);
    } catch (err) {
      console.log("ERROR: ", err);
    }
  };
  // console.log({ variables });
  const exportStatus = useMemo(() => {
    if (!variables) return null;
    if (
      variables.export_status == null &&
      !variables.imum_rule &&
      !variables.export_date
    )
      return null;

    const recordType =
      variables.export_status == null && !!variables.imum_rule
        ? "pending"
        : variables.export_status
        ? "success"
        : "failed";
    return {
      recordType,
      color:
        recordType == "pending"
          ? "#9A5BD1"
          : recordType == "success"
          ? "#6BB416"
          : "#D60D00",
      export_date: variables.export_date,
      rule_name: variables.imum_rule,
    };
  }, [variables?.export_date, variables?.export_status, variables?.imum_rule]);

  // console.log({ exportStatus });

  const competitorPriceDifference = useMemo(() => {
    if (!old_price || !variables.cheapest_price) return 0;
    if (+old_price <= +variables.cheapest_price) return 0;

    return relDiff(+old_price, +variables.cheapest_price);
  }, [old_price, variables.cheapest_price]);

  if (countriesAreDisplayed && !countriesAreDisplayed.includes(country))
    return null;
  const active = activeParent == id;
  return (
    <StyledTd2
      className={
        active
          ? "bg-white text-sm position-relative"
          : "text-sm position-relative"
      }
      country={country}
      style={{
        width: 100,
        minHeight: 54,
      }}
      border_left={countriesAreDisplayed.at(0) == country}
      border_right={countriesAreDisplayed.at(-1) == country}
    >
      <div className="d-flex align-items-center justify-content-center">
        {old_price !== value && id && !active && (
          <Tooltip
            zIndex={999999}
            className="mr-2"
            placement="top"
            title={`Change to old price`}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center ml-1 cursor-pointer"
              style={{
                backgroundColor: "#5F5F5F",
                width: 12,
                height: 12,
              }}
              onClick={() => {
                return request(old_price);
              }}
            >
              <MdOutlinePriceCheck size={7} color="#fff" />
            </div>
          </Tooltip>
        )}
        {competitorPriceDifference > 30 && (
          <Tooltip
            zIndex={999999}
            className="mr-2"
            placement="top"
            title={`Competitor's price lower when yours about ${numberRound(
              competitorPriceDifference
            )}%, yours ${numberRound(old_price)}, competitor ${numberRound(
              variables.cheapest_price
            )} `}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center ml-1"
              style={{
                backgroundColor: "#5F5F5F",
                width: 12,
                height: 12,
              }}
            >
              <AiOutlineExclamation size={7} color="#fff" />
            </div>
          </Tooltip>
        )}
        <div className={active ? "flex-1" : ""}>
          {active ? (
            <div className="position-relative">
              <del
                className="position-absolute"
                style={{
                  fontSize: 10,
                  top: "-10px",
                }}
              >
                {value}
              </del>
              <input
                ref={inputRef}
                style={{
                  width: 50,
                  border: "none",
                  padding: "none",
                  margin: "none",
                }}
                placeholder="Type in"
                value={inputValue}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    return handleSave();
                  }
                  if (e.key == "Escape") return handleActive();
                  // console.log(e.key);
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  setInputValue(value);
                }}
              />
            </div>
          ) : (
            <nobr>{returnEuroString(value)}</nobr>
          )}
        </div>
        {id && (
          <div className="ml-2">
            {active ? (
              <div className="d-flex flex-row">
                <div
                  className="d-flex flex-column pr-1"
                  style={{
                    borderRight: "1px solid #F2F2F2",
                  }}
                >
                  <Tooltip zIndex={999999} placement="right" title="Apply">
                    <IconBlockSuccess onClick={() => handleSave()} />
                  </Tooltip>
                  <div className="my-1"></div>
                  <Tooltip zIndex={999999} placement="right" title="Cancel">
                    <IconBlockDenied onClick={() => handleActive()} />
                  </Tooltip>
                </div>
                <div className="d-flex flex-column ml-1">
                  <Tooltip
                    zIndex={999999}
                    placement="right"
                    title="Apply price for other countries"
                  >
                    <IconBlockApply onClick={() => handleSave("related_ids")} />
                  </Tooltip>
                </div>
              </div>
            ) : (
              <IconEdit
                color="#5F5F5F"
                onClick={() => {
                  handleActive(id);
                  setInputValue(numberRound(value) || "");
                }}
              />
            )}
          </div>
        )}
      </div>
      {!active && variables.suspectful_price && (
        <div
          className="position-absolute"
          style={{
            bottom: 5,
            left: "50%",
            transform: "translate(-50%, 0px)",
          }}
        >
          <Tooltip
            zIndex={999999}
            placement="top"
            title={`Suspectful price: Price difference ${variables.suspectful_price}% or ${returnEuroString(
              value > old_price ? value - old_price : old_price - value
            )} `}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center ml-1"
              style={{
                backgroundColor: "#D60D00",
                width: 15,
                height: 15,
              }}
            >
              <AiOutlineExclamation size={10} color="#fff" />
            </div>
          </Tooltip>
        </div>
      )}
      {!!exportStatus && (
        <div
          className="position-absolute"
          style={{
            left: 0,
            top: 0,
            // transform: "translate(-50%, 0px)",
          }}
        >
          <Tooltip
            zIndex={999999}
            placement="top"
            title={
              exportStatus.recordType == "failed" ? (
                <div>
                  <div className="text-center font-medium">
                    Failed to import date
                  </div>
                  <div className="text-center">
                    {exportStatus.export_date
                      ? formatDateTime(exportStatus.export_date)
                      : "Not imported yet"}
                  </div>
                  {!!exportStatus.rule_name && (
                    <>
                      <div className="text-center font-medium">Rule</div>
                      <div className="text-center">
                        {exportStatus.rule_name}
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div>
                  <div className="text-center font-medium">Import date</div>
                  <div className="text-center">
                    {exportStatus.export_date
                      ? formatDateTime(exportStatus.export_date)
                      : "Not imported yet"}
                  </div>
                  {!!exportStatus.rule_name && (
                    <>
                      <div className="text-center font-medium">Rule</div>
                      <div className="text-center">
                        {exportStatus.rule_name}
                      </div>
                    </>
                  )}
                </div>
              )
            }
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: exportStatus.color,
                borderBottomRightRadius: 5,
                padding: "3px",
              }}
            >
              {exportStatus.recordType == "success" ? (
                <MdCheckCircleOutline
                  className="text-white"
                  style={{
                    width: 14,
                    height: 14,
                  }}
                />
              ) : exportStatus.recordType == "failed" ? (
                <IconExclamation className="text-white" />
              ) : (
                <IconSandTimer
                  className="text-white"
                  style={{
                    width: 14,
                    height: 14,
                  }}
                />
              )}
            </div>
          </Tooltip>
        </div>
      )}
    </StyledTd2>
  );
};

export default ImumNewPriceChange;

const StyledTd2 = styled.td`
  min-width: 100px;
  text-align: center;
  vertical-align: middle !important;
  background-color: ${(props) =>
    props.country == "LV"
      ? "rgba(200, 82, 96, 0.12)"
      : props.country == "LT"
      ? "rgba(255, 206, 49, 0.12)"
      : props.country == "EE"
      ? "rgba(66, 173, 226, 0.12)"
      : "rgb(0 150 136 / 14%)"};
  border-left: ${(props) =>
    props.border_left ? "1px solid rgb(191, 191, 191)" : "none"};
  border-right: ${(props) =>
    props.border_right ? "1px solid rgb(191, 191, 191)" : "none"};
`;
